import { routes } from '@platform/core/lib/routes';

/**
 * Посилання на «Усі модулі», відфільтровані за групою верхнього меню (крихта групи, «Показати в „Усі модулі“ →» випадного меню групи);
 * без групи — уся сторінка. Ключ 'pinned' — закріплені модулі, 'system' — системні модулі.
 */
export const modulesLink = (group?: string | null): string =>
  `${routes.modules()}${group ? `?group=${encodeURIComponent(group)}` : ''}`;
